function __range__(left, right, inclusive) {
    const range = [];
    const ascending = left < right;
    const end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
        range.push(i);
    }
    return range;
}

function rangeFilter() {
    'ngInject';

    return function (input, min, max) {
        (__range__(parseInt(min), parseInt(max), true).map(i => input.push(i)));
        return input;
    };
}

angular
    .module('BB')
    .filter('range', rangeFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/range.filter.js